import { Row } from './toRows';

const MAX_ROWS = 200;

const cell = (value: unknown) =>
  value === null || value === undefined
    ? '—'
    : typeof value === 'object'
      ? JSON.stringify(value)
      : String(value);

export const RowsTable = ({ rows }: { rows: Row[] }) => {
  if (rows.length === 0) return null;
  const shown = rows.slice(0, MAX_ROWS);
  const columns = Array.from(new Set(shown.flatMap((r) => Object.keys(r))));
  return (
    <div className="system-rows">
      <table>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c}>{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {shown.map((r, i) => (
            <tr key={i}>
              {columns.map((c) => (
                <td key={c}>{cell(r[c])}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {rows.length > MAX_ROWS && <p className="team-muted">+{rows.length - MAX_ROWS}</p>}
    </div>
  );
};
